var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDesc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 13.229 13.229",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.48382 0 0 .75463 3.8004 .73167)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#B9B9BF",
    strokeWidth: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-6.336 0.43287c-0.83896 0-1.5191 0.47093-1.5191 1.0518 0 0.58091 0.68012 1.0518 1.5191 1.0518h24.305c0.83883 0 1.5191-0.47093 1.5191-1.0518 0-0.58091-0.68025-1.0518-1.5191-1.0518z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-6.336 8.8475c-0.83896 0-1.5191 0.47093-1.5191 1.0518 0 0.58091 0.68012 1.0518 1.5191 1.0518h24.305c0.83883 0 1.5191-0.47093 1.5191-1.0518 0-0.58091-0.68025-1.0518-1.5191-1.0518z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-6.336 4.6402c-0.83896 0-1.5191 0.47093-1.5191 1.0518 0 0.58091 0.68012 1.0518 1.5191 1.0518h24.305c0.83883 0 1.5191-0.47093 1.5191-1.0518 0-0.58091-0.68025-1.0518-1.5191-1.0518z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-6.6398 13.055c-0.67117 0-1.2153 0.47093-1.2153 1.0518 0 0.58091 0.5441 1.0518 1.2153 1.0518h19.444c0.67107 0 1.2153-0.47093 1.2153-1.0518 0-0.58091-0.5442-1.0518-1.2153-1.0518z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesc);
export default __webpack_public_path__ + "static/media/desc.069ec61d7f97275272d656e45ca60e5e.svg";
export { ForwardRef as ReactComponent };